import ModalTitleContainer from "../../../../components/Modal/components/ModalTitleContainer";
import {StyledButton} from "../../../../components/Buttons/DefaultButton/DefaultButton.styles";
import React from "react";
import {JobWithInvoiceProps} from "../InvoicePage";
import useActionApi from "../../../../hooks/useActionApi";
import Api from "../../../../api";
import FixedLoader from "../../../../components/FixedLoader/FixedLoader";


const getJobPaymentTerms = (days: number, hyg: boolean = true) =>  {
    switch (days) {
        case 1:
            return (hyg ? 'Within 24hrs' : 'The Day') + ' of the Shift';
        case 14:
            return 'Within 2 Weeks of the Shift';
        case 30:
            return 'Within 1 Month of the Shift';
    }
}

export const InvoiceAlreadyPaidModal = ({job, onCloseButtonClick, onPaid}: {job: JobWithInvoiceProps, onCloseButtonClick: (e?: any) => void, onPaid: (e?: any) => void }) => {

    const [updateAlreadyPaidInvoiceLoading, , updateAlreadyPaidInvoice] = useActionApi({
        apiMethod: Api.updateAlreadyPaidInvoice,
        onSuccess: () => onPaid()
    });

    const alreadyPaid = () => {
        updateAlreadyPaidInvoice(job.invoice.id);
    }

    return (
        <>
            <ModalTitleContainer title={'Has this invoice already been paid?'} onClose={onCloseButtonClick} />

            <div>
                Remember, the payment terms for this shift are
                <br/><b>{getJobPaymentTerms(job.paymentTerms)}</b>.<br/><br/>
                Has your office already paid and settled this invoice with {job.hygienist.firstName}?
            </div>

            <StyledButton
                variant="contained"
                color="primary"
                size="large"
                id="continue-button"
                onClick={alreadyPaid}
            >
                Yes
            </StyledButton>
            <StyledButton
                variant="outlined"
                color="primary"
                size="large"
                id="continue-button"
                onClick={onCloseButtonClick}
            >
                No
            </StyledButton>

            <FixedLoader loading={updateAlreadyPaidInvoiceLoading} />
        </>
    );
}